import fetchClient from '@/api/api-client'

export interface UploadResult {
  Location: string
}

export const uploadFile = async (file: File, fileName: string): Promise<UploadResult> => {
  try {
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      throw new Error(`file type not allowed: ${file.type}`)
    }
    const formData = new FormData()
    formData.append('file', file)
    formData.append('name', fileName)

    const res = await fetchClient.post(`/file/upload`, formData)
    // console.log("uploadFile - res:", res)

    return res.data.data
  } catch (error) {
    console.log('uploadFile - error:', error)
    throw error
  }
}

export const uploadReceipt = async (file: File, fileName: string): Promise<UploadResult> => {
  try {
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      throw new Error(`file type not allowed: ${file.type}`)
    }
    const formData = new FormData()
    formData.append('file', file)
    formData.append('name', fileName)

    const res = await fetchClient.post(`/file/uploadReceipt`, formData)
    // console.log("uploadFile - res:", res)

    return res.data.data
  } catch (error) {
    console.log('uploadFile - error:', error)
    throw error
  }
}
